/*
 *		Copyright (c) 2011-2023 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('accessWebClient')
    .constant('RecipientType', {
        EMAIL: 'email',
        GROUP: 'group'
    })
    .directive('accRecipientSuggestions', () => ({
        restrict: 'E',
        scope: {
            placeholderText: '@',
            includeShareGroups: '<',
            onUpdate: '&'
        },
        template: '\
            <acc-chips-input\
                id="invitations"\
                name="invitations"\
                placeholder="{{ placeholderText }}"\
                ng-model="recipients"\
                separators=", ;"\
                load-suggestions="loadSuggestions(query)"\
                validate-input="validateUserInput(input)"\
                chip-formatter="formatChip(chip)"\
                required\
            ></acc-chips-input>',
        controller: [
            '$scope',
            'RecipientType',
            'EmailTools',
            'loadEmailSuggestions',
            'ShareGroupsResource',
            (
                $scope,
                RecipientType,
                EmailTools,
                loadEmailSuggestions,
                ShareGroupsResource
            ) => {
            $scope.recipients = [];
            $scope.$watch('recipients', (recipients) => $scope.onUpdate({ recipients }));
            $scope.validateUserInput = (input) => EmailTools.isValid(input);
            $scope.formatChip = (chip) => {
                const type = chip.type || RecipientType.EMAIL;
                return {
                    label: angular.isString(chip) ? chip : chip.name,
                    icon: type === RecipientType.EMAIL ? 'icon-acc-members' : 'icon-acc-share-groups'
                }
            };
            $scope.loadSuggestions = async (query) => {
                const suggestions = [
                    ...await _getGroupSuggestions(query),
                    ...await _getEmailSuggestions(query)
                ];

                return suggestions
                    .filter((suggestion) => (
                        !$scope.recipients ||
                        !$scope.recipients.some(_isSuggestionInList(suggestion))
                    ));
            };

            const _getEmailSuggestions = async (query) => {
                const { data: emailSuggestions } = await loadEmailSuggestions(query);

                return emailSuggestions.map((email) => ({
                    label: email.text,
                    value: email.email,
                    icon: 'icon-acc-members'
                }))
            };

            const _getGroupSuggestions = async (query) => {
                if ($scope.includeShareGroups === false) {
                    return [];
                }

                const groupSuggestions = await ShareGroupsResource.query({query}).$promise;

                return groupSuggestions.map((group) => ({
                    label: group.name,
                    icon: 'icon-acc-share-groups',
                    value: {
                        ...group,
                        type: RecipientType.GROUP,
                    }
                }))
            }

            const _isSuggestionInList = (suggestion) => (recipientSuggestion) => {
                if(angular.isString(recipientSuggestion)) {
                    return recipientSuggestion === suggestion.label;
                } else {
                    return recipientSuggestion.name === suggestion.label;
                }
            };
        }]
    }))
